var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var BagSvg = /* @__PURE__ */ __name(function BagSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M20.72 13.942c-0.614 0-1.111-0.497-1.111-1.111v0-5.36c0.001-0.031 0.002-0.068 0.002-0.104 0-1.866-1.479-3.386-3.329-3.451l-0.006-0h-0.556c-1.856 0.066-3.335 1.586-3.335 3.451 0 0.037 0.001 0.073 0.002 0.11l-0-0.005v5.36c0 0.614-0.497 1.111-1.111 1.111s-1.111-0.497-1.111-1.111v0-5.36c-0.001-0.031-0.001-0.067-0.001-0.103 0-3.093 2.474-5.608 5.55-5.674l0.006-0h0.556c3.083 0.067 5.556 2.582 5.556 5.674 0 0.036-0 0.073-0.001 0.109l0-0.005v5.36c0 0.614-0.497 1.111-1.111 1.111v0z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M26.502 10.387v17.778h-21.004v-17.778h21.004zM28.724 8.164h-25.449v22.222h25.449v-22.222z"
  }));
}, "BagSvg");
var BagIcon = /* @__PURE__ */ __name(function BagIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: BagSvg
  }, props));
}, "BagIcon");
export {
  BagIcon
};
